import contestLarge from './contest-badge-large.png';
import contestSmall from './contest-badge-small.png';
import featuredLarge from './featured-badge-large.png';
import featuredSmall from './featured-badge-small.png';
import soldLarge from './sold-badge-large.png';
import soldSmall from './sold-badge-small.png';

const images = {contestSmall, contestLarge, featuredLarge, featuredSmall, soldLarge, soldSmall};

export default images;
